import React from 'react'
import { useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import { useEffect } from 'react';
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

function Categorys() {
    const [Categories,setCategories] = useState([])
    const HandleClickdelete = (categoryid) => {
      axios.delete(process.env.REACT_APP_API_URL+`/api/DeleteCategory/${categoryid}`)
        .then((res) => {
          console.log(res);
          console.log(res.data);
          window.location.href = "/categories";
        })
        .catch((err) => {
          console.error(err);
        });
    };
    useEffect(() => {
        axios
          .get(process.env.REACT_APP_API_URL+"/api/Category").then((res) => {setCategories(res.data)}).catch((err) => {console.error(err);});
        }
        ,[]);
  return (
    <>
    <div>
    <div className="h-10 m-0 p-0 bg-slate-500 opacity-30" style={{borderRadius:'4px'}}>
          <input type="text" className=" m-2" style={{borderRadius: '4px'}} placeholder="Search"/>
        </div>
      <section className="mx-auto w-full max-w-7xl px-4 py-4">
        <div className="flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
          <div>
            <h2 className="text-lg font-semibold">Categories</h2>
            <p className="mt-1 text-sm text-gray-700">
              This is a list of all Categories. You can add new Category, edit or delete existing
              ones.
            </p>
          </div>
          <div>
            <button
              type="button"
              className="rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
            >
              <NavLink to="/categories/addcategory">Add Category</NavLink>
            </button>
          </div>
        </div>
        <div className="mt-6 flex flex-col">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
              <div className="overflow-hidden border border-gray-200 md:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-sm font-normal text-gray-700"
                      >
                        <span>Category</span>
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-sm font-normal text-gray-700"
                        >Code</th>
                        <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-sm font-normal text-gray-700"
                        >Active</th>
                        <th
                        scope="col"
                        className="px-4 py-3.5 text-left text-sm font-normal text-gray-700"
                        ></th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {Categories.map((category) => (
                      <tr key={category.id}
                      >
                        <td className="px-4 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div className="text-sm font-medium text-gray-900">{category.name}</div>
                          </div>
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">{category.code}</div>
                        </td>
                       <td className="px-4 py-4 whitespace-nowrap">

                          
                            {category.isactive ? 
                             <span className="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">
                             Active
                         </span> 
                         : 
                         <span className="inline-flex rounded-full bg-red-100 px-2 text-xs font-semibold leading-5 text-red-800">  
                             Disabled 
                         </span>}
                  
                        </td>
                        <td className=" buuton2">
                         
                            <NavLink 
                            className="mr-2  text-indigo-600 hover:text-indigo-900  "
                            to={`/categories/editcategory/${category.id}`}><FaEdit/></NavLink>
                          <button
                            type="button"
                            className="text-red-600 hover:text-red-900 "
                            onClick={() => HandleClickdelete(category.id)}
                          >
                            <MdDelete/></button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    </>
  )
  }

export default Categorys;